import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { ApolloLink } from "@apollo/client";
import { onError } from "@apollo/client/link/error";
import { GraphqlErrorInterceptor, GraphQLExtensions } from "@zen/core/models/graphql-interface.model";
import { getTranslation } from '@zen/core/utilities/translate.util';
import { SnackbarService } from "@zen/ui/services/snackbar.service";
@Injectable({
  providedIn: 'root',
})

export class studioInterceptor implements GraphqlErrorInterceptor{
  constructor(
    private route: Router,
    private snackBarService: SnackbarService
  ){}
   apolloError(): ApolloLink {
     return onError(({ graphQLErrors, networkError }) => {
       if (graphQLErrors) {
         graphQLErrors.forEach((error: GraphQLExtensions) => {
           if (error?.httpStatusCode === 401 || error?.httpStatusCode === 403) {
             if (typeof window !== 'undefined' && window.location.pathname.includes('/marketplace')) {
               return;
             }
             this.snackBarService.showSnackBar({
               actionType: "error",
               prefixIcon: 'error',
               message: getTranslation('COMMON.SOMETHING_WENT_WRONG'),
               buttonType: 'button',
               buttonText: getTranslation('COMMON.OKAY'),
             });
             this.route.navigate(['signin']);
           }
         })
       }
       if (networkError) {
         this.snackBarService.showSnackBar({
           actionType: "error",
           prefixIcon: 'error',
           message: getTranslation('COMMON.SOMETHING_WENT_WRONG'),
           buttonType: 'button',
           buttonText: getTranslation('COMMON.OKAY'),
         });
        //  this.route.navigate(['signin']);
        //  console.error('Network Error:', networkError);
       }
     })
   }
}